module.exports = __webpack_public_path__ + "img/Vince_Headshot-photoaidcom-cropped.7bcb7575.JPG";